<template>
  <div class="c-pc-guest">
    <div class="guest-row" v-for="(list, i) in guestsLists" :key="list.guestId">
      <div
        class="guest-items"
        v-for="(item, j) in list"
        :style="{ flex: list.length == 1 ? '0 0 47.8%' : '1' }"
        :key="item.guestId"
      >
        <div class="guest-vatar">
          <img :src="item.headImgUrl || defaultImageUrl" alt="头像" />
        </div>
        <div class="guest-info">
          <div class="guest-name">{{ item.name }}</div>
          <div
            class="guest-position"
            :title="item.enterprise + ' ' + item.duty"
          >
            {{ item.enterprise }} {{ item.duty }}
          </div>
          <div
            class="guest-text"
            :id="'guest-items' + j + i"
            :class="{ show: !item.showMoreStatus }"
          >
            {{ item.intro }}
          </div>
        </div>
        <div
          class="guset-more"
          v-if="item.showMore"
          @click="changeShowMore(item)"
        >
          <span
            class="icon icontemp"
            :class="{ down: item.showMoreStatus, up: !item.showMoreStatus }"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $subscriber, cr } from "fire-wind-water";

export default {
  name: "Guests",
  data() {
    return {
      guestsLists: [],
      defaultImageUrl: require("../../assets/images/guest-def.jpg")
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const self = this;
      $subscriber.subscribe("webinarInfo", data => {
        let arr = [];
        data.guestList.forEach((list, i) => {
          list.showMore = false;
          list.showMoreStatus = false;
          const n = parseInt(i / 2);
          if (!arr[n]) {
            arr[n] = [];
          }
          arr[n].push(list);
        });
        this.guestsLists = arr;
        setTimeout(() => {
          self.isShowMore();
        }, 100);
      });
    },
    isShowMore() {
      cr.each(this.guestsLists, (list, i) => {
        cr.each(list, (item, j) => {
          if (
            document.getElementById("guest-items" + j + i).scrollHeight > 90
          ) {
            item.showMore = true;
            item.showMoreStatus = true;
          } else {
            item.showMore = false;

            item.showMoreStatus = false;
          }
        });
      });
    },
    changeShowMore(item) {
      item.showMoreStatus = !item.showMoreStatus;
    }
  }
};
</script>

<style scoped></style>
